.site-footer {
  width: 100%;
  padding: 48px 0 0;
  background: var(--color-page);
  color: var(--color-ink);
}

.footer-main {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 0.9fr) minmax(
      190px,
      0.85fr
    ) minmax(0, 0.7fr);
  gap: clamp(24px, 3vw, 48px);
  width: min(100% - 108px, 1600px);
  margin-inline: auto;
  padding-bottom: 36px;
}

.footer-brand {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
}

.footer-logo {
  display: inline-flex;
  align-items: center;
  width: 180px;
  margin-bottom: 16px;
}

.footer-logo img {
  display: block;
  width: 100%;
  max-height: 52px;
  object-fit: contain;
  object-position: left center;
}

.footer-description {
  max-width: 440px;
  margin: 0 0 18px;
  color: var(--color-body);
  font-size: 0.95rem;
  line-height: 1.7;
}

.footer-contact {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
  margin-bottom: 16px;
}

.footer-email {
  display: flex;
  align-items: center;
  gap: 12px;
}

.footer-contact a {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--color-body);
  font-size: 0.82rem;
  text-decoration: none;
  transition: color 180ms ease;
}

.footer-contact a:hover {
  color: var(--color-brand-dark);
}

.footer-contact svg {
  flex-shrink: 0;
}

.footer-copy-email {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: var(--color-muted);
  cursor: pointer;
  transition:
    color 180ms ease,
    background-color 180ms ease;
}

.footer-copy-email:hover {
  background: var(--color-surface-alt);
  color: var(--color-brand-dark);
}

.footer-socials {
  display: flex;
  align-items: center;
  gap: 9px;
}

.footer-social-link {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border);
  border-radius: 50%;
  color: var(--color-body);
  transition:
    color 180ms ease,
    border-color 180ms ease,
    background-color 180ms ease;
}

.footer-social-link:hover {
  border-color: var(--color-brand);
  background: var(--color-brand);
  color: #fff;
}

.footer-column {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
}

.footer-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 2px 0 14px;
  color: var(--color-muted);
  font-family: var(--font-mono);
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.2em;
  line-height: 1.5;
  white-space: nowrap;
  text-transform: uppercase;
}

.footer-heading-mark {
  color: var(--color-brand);
  font-size: 1rem;
}

.footer-links {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.footer-link {
  display: inline-flex;
  max-width: 100%;
  align-items: flex-start;
  gap: 6px;
  color: var(--color-body);
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.5;
  text-decoration: none;
  overflow-wrap: anywhere;
  transition: color 180ms ease;
}

.footer-link:hover {
  color: var(--color-brand-dark);
}

.footer-sports-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 3px;
  color: var(--color-brand);
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  transition: color 180ms ease;
}

.footer-sports-link:hover {
  color: var(--color-brand-dark);
}

.footer-sports-link svg {
  flex-shrink: 0;
  transition: transform 180ms ease;
}

.footer-sports-link:hover svg {
  transform: translate(2px, -2px);
}

.footer-offices-section {
  width: min(100% - 108px, 1600px);
  margin-inline: auto;
  padding: 22px 0 26px;
  border-top: 1px solid var(--color-border);
}

.footer-offices {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
  width: 100%;
}

.footer-office {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
  font-style: normal;
}

.footer-office-country {
  color: var(--color-brand);
  font-family: var(--font-mono);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.footer-office-address {
  max-width: 300px;
  color: var(--color-muted);
  font-size: 0.75rem;
  line-height: 1.65;
}

.footer-bottom {
  display: flex;
  width: min(100% - 108px, 1600px);
  min-height: 56px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-inline: auto;
  border-top: 1px solid var(--color-border);
}

.footer-copyright {
  margin: 0;
  color: var(--color-muted);
  font-family: var(--font-mono);
  font-size: 0.63rem;
  letter-spacing: 0.04em;
  line-height: 1.7;
}

.footer-legal {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
}

.footer-legal a {
  color: var(--color-muted);
  font-size: 0.7rem;
  text-decoration: none;
  transition: color 180ms ease;
}

.footer-legal a:hover {
  color: var(--color-brand-dark);
}

@media (max-width: 1100px) {
  .footer-main {
    grid-template-columns: minmax(0, 1.4fr) minmax(0, 1.1fr) repeat(
        2,
        minmax(0, 0.75fr)
      );
    gap: 28px;
  }

  .footer-offices {
    gap: 20px;
  }
}

@media (max-width: 900px) {
  .site-footer {
    padding-top: 40px;
  }

  .footer-main,
  .footer-offices-section,
  .footer-bottom {
    width: calc(100% - 56px);
  }

  .footer-main {
    grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 0.8fr);
    gap: 32px 28px;
    padding-bottom: 32px;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }

  .footer-description {
    max-width: 560px;
  }

  .footer-offices {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px 32px;
  }

  .footer-office-address {
    max-width: 360px;
  }
}

@media (max-width: 600px) {
  .site-footer {
    padding-top: 32px;
  }

  .footer-main,
  .footer-offices-section,
  .footer-bottom {
    width: calc(100% - 36px);
  }

  .footer-main {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 26px 20px;
    padding-bottom: 28px;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }

  .footer-services {
    grid-column: 1 / -1;
  }

  .footer-logo {
    width: 140px;
    margin-bottom: 12px;
  }

  .footer-description {
    max-width: 440px;
    margin-bottom: 14px;
    font-size: 0.875rem;
    line-height: 1.6;
  }

  .footer-contact {
    margin-bottom: 14px;
  }

  .footer-social-link {
    width: 34px;
    height: 34px;
  }

  .footer-heading {
    gap: 8px;
    margin: 0 0 10px;
    font-size: 0.68rem;
    letter-spacing: 0.14em;
  }

  .footer-links {
    gap: 8px;
  }

  .footer-link {
    font-size: 0.78rem;
  }

  .footer-sports-link {
    font-size: 0.64rem;
    letter-spacing: 0.04em;
  }

  .footer-offices-section {
    padding: 20px 0 22px;
  }

  .footer-offices {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px 16px;
  }

  .footer-office {
    gap: 4px;
  }

  .footer-office-address {
    font-size: 0.72rem;
    line-height: 1.55;
  }

  .footer-bottom {
    min-height: auto;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-block: 14px;
  }

  .footer-copyright {
    font-size: 0.58rem;
  }

  .footer-legal {
    gap: 8px 18px;
  }
}

@media (max-width: 380px) {
  .footer-main {
    gap: 22px 16px;
  }

  .footer-heading {
    font-size: 0.62rem;
  }

  .footer-link {
    font-size: 0.74rem;
  }

  .footer-offices {
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .footer-link,
  .footer-contact a,
  .footer-social-link,
  .footer-legal a,
  .footer-sports-link,
  .footer-sports-link svg,
  .footer-copy-email {
    transition: none;
  }
}